import React, { useEffect, useState } from 'react';
import './pdaSettingsAdmin.scss';
import { IUser } from '../../models';
import PaneHeadline from '../shared/paneHeadline';
import { faCaretLeft, faCogs } from '@fortawesome/free-solid-svg-icons';
import { IPDASetting } from '../../models/IPDASetting.model';
import { getCustomerIdInUse } from '../../utils/GeneralUtils';
import { Spinner2 } from '../shared/spinner2';
import PdaSettingsGrid from './PdaSettingsGrid';
import PdaSettingModal from './PdaSettingModal';
import { locale } from '../../common/localization/localizationService';
import routes from '../../common/routes';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EventBus from '../../common/EventBus';

export interface IPdaSettingsAdminProps {
  impersonatedUser: any;
  authentication: IUser;
  pdaSettingsList: Array<IPDASetting>;
  isLoading: boolean;
  getPdaSettings: (ignoreCache: boolean) => void;
}

export default function PdaSettingsAdminPage(
  props: IPdaSettingsAdminProps,
): JSX.Element {
  const customerId = getCustomerIdInUse(props.authentication);

  useEffect(() => {
    props.getPdaSettings(false);
  }, []);

  useEffect(() => {
    EventBus.emit('fullScreenChange', true);

    return () => {
      EventBus.emit('fullScreenChange', false);
    };
  }, []);

  const [showModal, setShowModal] = useState(false);

  const [selectedPDASetting, setSelectedPDASetting] = useState(null);

  const openModal = (dataItem: IPDASetting) => {
    setSelectedPDASetting(dataItem);
    setShowModal(true);
  };

  const hideModal = (rerender: boolean) => {
    setShowModal(false);
    setSelectedPDASetting(null);
    if (rerender) {
      props.getPdaSettings(rerender);
    }
  };

  const existingParameters = props.pdaSettingsList.map((setting) => {
    return setting.parameter;
  });

  return (
    <div className="pda-settings-admin-page">
      <div className="row">
        <PaneHeadline
          titleIcon={faCogs}
          titleText={locale.pdaSettings._pdaSettings}
          className="col-sm-6"
        />
        <div className="col-sm-6 text-right mb-3">
          <Link to={routes.administration.base} className="back-nav-button">
            <button className="btn btn-outline-dark">
              <FontAwesomeIcon icon={faCaretLeft} /> {locale.vehicles._vehicles}
            </button>
          </Link>
          <button
            className="btn btn-outline-dark"
            onClick={() => openModal(null)}
          >
            {locale.pdaSettings._newPDASetting}
          </button>
        </div>
      </div>
      <Spinner2 show={props.isLoading} />
      <PdaSettingsGrid
        data={props.pdaSettingsList}
        editPdaSetting={openModal}
      />
      {showModal && (
        <PdaSettingModal
          customerId={customerId}
          onHide={hideModal}
          pdaSetting={selectedPDASetting}
          show={showModal}
          existingParameters={existingParameters}
        />
      )}
    </div>
  );
}
